import './LeftPanel.scss';

import { useEffect } from 'react';
import HomebaseLogo from 'fe-design-base/assets/Logo/logos/HomebaseLogo';
import Box from 'fe-design-base/atoms/Box';
import Text from 'fe-design-base/atoms/Text';

import { cxHelpers } from 'util/className';
import {
  EVENT_ACTIONS,
  EVENT_CATEGORIES,
  PRODUCT_AREAS,
  TRACK_ACTION_TYPES,
} from 'util/tracking_constants';
import { useExtendUx, useTrackUx, withUxRoot } from 'util/uxEvents';

const { cx, cxEl } = cxHelpers('LeftPanel');

export const LeftPanel = () => {
  const trackUx = useTrackUx();
  const extendUxEvent = useExtendUx();

  extendUxEvent({
    component: 'LeftPanel',
  });

  useEffect(() => {
    trackUx(EVENT_ACTIONS.SECTION_VIEWED, TRACK_ACTION_TYPES.VIEW);
  }, [trackUx]);

  return (
    <Box className={cx()} h="auto" color="mono0">
      <Box p={16} ml={32} mt={32} h={27} w={168}>
        <HomebaseLogo />
      </Box>

      <Box
        w="100%"
        m="0 auto"
        className={cxEl('wrapper')}
        column
        alignItemsBaseline
        justifyContentSpaceEvenly
      >
        <Box w="96%" justifyContentCenter>
          <img height="400" width="493" src={require('./lw.png')} />
        </Box>

        <Box w="55%" ml={32} gap={8} column>
          <Text
            variant="heading1"
            i18n="splash_page.left_panel.header"
            asHTML
          />

          <Text i18n="splash_page.left_panel.body" asHTML />
        </Box>
      </Box>
    </Box>
  );
};

export default withUxRoot({
  productArea: PRODUCT_AREAS.SIGN_IN,
  eventCategory: EVENT_CATEGORIES.SIGN_IN,
})(LeftPanel);
